import { jsx as _jsx } from "react/jsx-runtime";
export function Sector({ cx, cy, rx, ry, ...rest }) {
    let startRad, endRad;
    let pathProps;
    if ('startRad' in rest) {
        ({ startRad, endRad, ...pathProps } = rest);
    }
    else {
        let startDeg, endDeg;
        ({ startDeg, endDeg, ...pathProps } = rest);
        startRad = (startDeg / 180) * Math.PI;
        endRad = (endDeg / 180) * Math.PI;
    }
    const startX = Math.cos(startRad) * rx + cx;
    const startY = Math.sin(startRad) * ry + cy;
    const endX = Math.cos(endRad) * rx + cx;
    const endY = Math.sin(endRad) * ry + cy;
    const largeArc = Math.abs(endRad - startRad) > Math.PI;
    const sweep = endRad > startRad;
    return (_jsx("path", { ...pathProps, d: `
              M ${startX} ${startY}
              A ${rx} ${ry}
                 0 ${largeArc ? 1 : 0} ${sweep ? 1 : 0}
                ${endX} ${endY}
            ` }));
}
